import React from 'react';

import validate from '@vlabs/shared/validators';
import {
  Control, Margin, Grid, GridRow, GridCol,
} from '@vlabs/uikit';
import { useForm } from 'react-hook-form';

import st from './CreateHandlerForm.module.sass';
import { useCreateHandlerTranslation } from './i18n';
import { OwnerDepartmentSelect } from './OwnerDepartmentSelect';

export interface DefineAttributesFormValues {
  description?: string;
  owner_department_id: string;
}

interface DefineAttributesFormProps {
  onSubmit: (values: DefineAttributesFormValues) => void;
}
function DefineAttributesForm({
  onSubmit,
}: DefineAttributesFormProps): React.JSX.Element {
  const { t } = useCreateHandlerTranslation();
  const {
    control, register, handleSubmit, setValue, formState: { errors },
  } = useForm<DefineAttributesFormValues>();

  return (
    <form
      data-testid="modal.defineAttributes"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Grid>
        <GridRow>
          <GridCol>
            <Margin display="block">
              <span className={st.Description}>
                {t('form.attributes_description')}
              </span>
            </Margin>
            <Margin display="block">
              <div className="Body-2">
                {t('form.name')}
              </div>
              <Control.Input
                {...register('description', {
                  maxLength: validate.maxLength(128),
                  required: validate.required(),
                })}
                errors={errors}
              />
            </Margin>
            <Margin display="block">
              <OwnerDepartmentSelect
                control={control}
                errors={errors}
                label={t('form.owner_department')}
                setValue={setValue}
              />
            </Margin>
          </GridCol>
        </GridRow>
      </Grid>
      <Margin display="block">
        <Control.Button
          fullWidth
          type="submit"
        >
          {t('form.create')}
        </Control.Button>
      </Margin>
    </form>
  );
}

export { DefineAttributesForm };
